module.exports = "build/assets/immigration.ecc049f6.png";